import arrayLength from './arrayLength';
export default function arrayIsEmpty(maybeArray) {
    return arrayLength(maybeArray) === 0;
}
